import { useQuery } from "@tanstack/react-query";
import licensingService from "../../../../services/web/licensing-service";

export function useLicensingQuery() {
    return useQuery({
        queryKey: ["licensingData"],
        queryFn: licensingService.getData,
    });
}